
import React, { useEffect, useRef, useState } from "react";
import lab2 from "../assets/doctor1.png";
import lab3 from "../assets/lab3.jpg";
import {
  CircularProgressbar,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function LabExperience() {
  /* ================= AUTO INCREMENT LOGIC ================= */
  const startDate = new Date("2020-12-06");
  const today = new Date();
  const daysPassed = Math.floor(
    (today - startDate) / (1000 * 60 * 60 * 24)
  );

  const counters = [
    {
      title: "Report Accuracy",
      base: 100,
      daily: 0,
      bg: "bg-red-500",
      mobile: { top: "0px", left: "60px" },
      desktop: { top: "0px", left: "110px" },
      isPercent: true,
      max: 100,
    },
    {
      title: "Happy Patient",
      base: 600,
      daily: 5,
      bg: "bg-red-800",
      mobile: { top: "180px", left: "40px" },
      desktop: { top: "150px", left: "100px" },
      isPercent: false,
    },
  ];

  const finalValues = counters.map((c) =>
    Math.floor(c.base + c.daily * daysPassed)
  );

  const [counts, setCounts] = useState(counters.map(() => 0));
  const ref = useRef(null);
  const started = useRef(false);
  const [isMobile, setIsMobile] = useState(false);

  /* ================= SCREEN SIZE ================= */
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  /* ================= SCROLL ANIMATION ================= */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;

          finalValues.forEach((target, i) => {
            let current = 0;
            const inc = Math.ceil(target / 80);

            const timer = setInterval(() => {
              current += inc;
              if (current >= target) {
                current = target;
                clearInterval(timer);
              }
              setCounts((prev) => {
                const copy = [...prev];
                copy[i] = current;
                return copy;
              });
            }, 20);
          });
        }
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="doctors" ref={ref} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">

        {/* ================= LEFT ================= */}
        <div className="relative">
          <h2 className="text-2xl md:text-3xl font-bold text-red-700 text-center mb-4">
            Pathology Admin
          </h2>

          <div className="grid grid-cols-1 gap-4">
            <div className="flex justify-center">
              <img
                src={lab2}
                alt="Doctor"
                className="w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-red-600"
              />
            </div>

            <div className="relative h-52 md:h-64 rounded-lg overflow-hidden">
              <img src={lab3} className="w-full h-full object-cover" alt="Lab" />

              <div className="absolute bottom-4 left-1/2 -translate-x-1/2
                w-48 h-48 bg-red-600 text-white rounded-lg
                flex flex-col justify-center items-center shadow-2xl">
                <span className="text-2xl">🔬</span>
                <h2 className="text-5xl font-bold">20</h2>
                <p className="text-sm">Years Experience</p>
                <p className="mt-2 font-semibold">Vijay Kanade</p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= RIGHT ================= */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-red-700 mb-6">
            Trusted Lab Experts and <br className="hidden md:block" />
            Latest Lab Technologies
          </h2>

          <p className="text-gray-500 mb-10">
            Accurate testing, modern equipment and trusted results.
          </p>

          {/* ================= COUNTERS ================= */}
          <div className="relative w-full h-[360px]">
            {counters.map((c, i) => {
              const pos = isMobile ? c.mobile : c.desktop;
              const maxValue = c.isPercent ? c.max : finalValues[i];

              return (
                <div
                  key={c.title}
                  style={{ top: pos.top, left: pos.left }}
                  className={`absolute ${c.bg}
                    w-[180px] h-[180px] md:w-[220px] md:h-[220px]
                    rounded-full flex flex-col justify-center items-center
                    shadow-2xl text-white`}
                >
                  <p className="text-sm mb-2">{c.title}</p>

                  <div className="w-24 h-24 md:w-28 md:h-28">
                    <CircularProgressbar
                      value={counts[i]}
                      maxValue={maxValue}
                      text={`${counts[i]}${c.isPercent ? "%" : ""}`}
                      styles={buildStyles({
                        textColor: "#fff",
                        pathColor: "#fff",
                        trailColor: "rgba(255,255,255,0.3)",
                        textSize: "16px",
                      })}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
